export default __webpack_public_path__ + "static/media/bg.70d52f73.svg";